export type MapProjection = {
  id: number;
  name: string;
  description_en: string;
  description_vi: string;
  proj: string;
  srs_code: string;
};

export const mapProjectionList: MapProjection[] = [
  {
    id: 1,
    name: 'Lat/Lon : WGS 84',
    description_en: 'World Geodetic System 1984',
    description_vi: 'Hệ toàn cầu EPSG:4326',
    proj: '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs',
    srs_code: 'WGS 84',
  },
  {
    id: 3,
    name: 'WGS 84 / UTM zone 48N',
    description_en: 'WGS 84 / UTM zone 48N',
    description_vi: 'Hệ tọa độ WGS 84 / UTM múi 48 độ Bắc EPSG:32648',
    proj: '+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs +type=crs',
    srs_code: 'EPSG:32648',
  },
  {
    id: 4,
    name: 'WGS 84 / UTM zone 49N',
    description_en: 'WGS 84 / UTM zone 49N',
    description_vi: 'Hệ tọa độ WGS 84 / UTM múi 49 độ Bắc EPSG:32649',
    proj: '+proj=utm +zone=49 +datum=WGS84 +units=m +no_defs +type=crs',
    srs_code: 'EPSG:32649',
  },
  {
    id: 5,
    name: 'WGS 84 / UTM zone 50N',
    description_en: 'WGS 84 / UTM zone 50N',
    description_vi: 'Hệ tọa độ WGS 84 / UTM múi 50 độ Bắc EPSG:32650',
    proj: '+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs +type=crs',
    srs_code: 'EPSG:32650',
  },
  {
    id: 6,
    name: 'VN2000: An Giang',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 7,
    name: 'VN2000: Bà Rịa - Vũng Tàu',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 8,
    name: 'VN2000: Bắc Giang',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-00 EPSG:9214',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-00',
  },
  {
    id: 9,
    name: 'VN2000: Bắc Kạn',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-30 EPSG:9213',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-30',
  },
  {
    id: 10,
    name: 'VN2000: Bạc Liêu',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 11,
    name: 'VN2000: Bắc Ninh',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 12,
    name: 'VN2000: Bến Tre',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 13,
    name: 'VN2000: Bình Định',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-15 EPSG:9217',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-15',
  },
  {
    id: 14,
    name: 'VN2000: Bình Dương',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 15,
    name: 'VN2000: Bình Phước',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-15 EPSG:9212',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-15',
  },
  {
    id: 16,
    name: 'VN2000: Bình Thuận',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 17,
    name: 'VN2000: Cà Mau',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-30 EPSG:9207',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-30',
  },
  {
    id: 18,
    name: 'VN2000: Cần Thơ',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 19,
    name: 'VN2000: Cao Bằng',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 20,
    name: 'VN2000: Đà Nẵng',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 21,
    name: 'VN2000: Đắc Lắc',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 22,
    name: 'VN2000: Đồng Nai',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 23,
    name: 'VN2000: Đồng Tháp',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 24,
    name: 'VN2000: Điện Biên',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 103-00 EPSG:9205',
    proj: '+proj=tmerc +lat_0=0 +lon_0=103 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_103-00',
  },
  {
    id: 25,
    name: 'VN2000: Gia Lai',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 26,
    name: 'VN2000: Hà Giang',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 27,
    name: 'VN2000: Hà Nam',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 28,
    name: 'VN2000: Hà Nội',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 29,
    name: 'VN2000: Hà Tây',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 30,
    name: 'VN2000: Hà Tĩnh',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 31,
    name: 'VN2000: Hải Dương',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 32,
    name: 'VN2000: Hải Phòng',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 33,
    name: 'VN2000: Hoà Bình',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-00 EPSG:9211',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-00',
  },
  {
    id: 34,
    name: 'VN2000: Hưng Yên',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 35,
    name: 'VN2000: Khánh Hoà',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-15 EPSG:9217',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-15',
  },
  {
    id: 36,
    name: 'VN2000: Kiên Giang',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-30 EPSG:9207',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-30',
  },
  {
    id: 37,
    name: 'VN2000: Kon Tum',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-30 EPSG:9216',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-30',
  },
  {
    id: 38,
    name: 'VN2000: Lai Châu',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 103-00 EPSG:9205',
    proj: '+proj=tmerc +lat_0=0 +lon_0=103 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_103-00',
  },
  {
    id: 39,
    name: 'VN2000: Lâm Đồng',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 40,
    name: 'VN2000: Lạng Sơn',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-15 EPSG:9215',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-15',
  },
  {
    id: 41,
    name: 'VN2000: Lào Cai',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 42,
    name: 'VN2000: Long An',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 43,
    name: 'VN2000: Nam Định',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 44,
    name: 'VN2000: Nghệ An',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 45,
    name: 'VN2000: Ninh Bình',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 46,
    name: 'VN2000: Long An',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 47,
    name: 'VN2000: Nam Định',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 48,
    name: 'VN2000: Nghệ An',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 49,
    name: 'VN2000: Ninh Bình',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 50,
    name: 'VN2000: Ninh Thuận',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-15 EPSG:9217',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-15',
  },
  {
    id: 51,
    name: 'VN2000: Phú Thọ',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 52,
    name: 'VN2000: Phú Yên',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 53,
    name: 'VN2000: Quảng Bình',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-00 EPSG:9211',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-00',
  },
  {
    id: 54,
    name: 'VN2000: Quảng Nam',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 55,
    name: 'VN2000: Quảng Ngãi',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-00',
  },
  {
    id: 56,
    name: 'VN2000: Quảng Ninh',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 57,
    name: 'VN2000: Quảng Trị',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-15 EPSG:9212',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-15',
  },
  {
    id: 58,
    name: 'VN2000: Sóc Trăng',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 59,
    name: 'VN2000: Sơn La',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-00 EPSG:9206',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-00',
  },
  {
    id: 60,
    name: 'VN2000: Tây Ninh',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 61,
    name: 'VN2000: Thái Bình',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 62,
    name: 'VN2000: Thái Nguyên',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-30 EPSG:9213',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-30',
  },
  {
    id: 63,
    name: 'VN2000: Thanh Hoá',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 64,
    name: 'VN2000: Tiền Giang',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 65,
    name: 'VN2000: Hồ Chí Minh',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 66,
    name: 'VN2000: Trà Vinh',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 67,
    name: 'VN2000: Thừa Thiên-Huế',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-00 EPSG:9214',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-00',
  },
  {
    id: 68,
    name: 'VN2000: Tuyên Quang',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-00 EPSG:9211',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-00',
  },
  {
    id: 69,
    name: 'VN2000: Vĩnh Long',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 70,
    name: 'VN2000: Vĩnh Phúc',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 71,
    name: 'VN2000: Yên Bái',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 72,
    name: 'VN2000: An Giang (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 73,
    name: 'VN2000: Bà Rịa - Vũng Tàu (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 74,
    name: 'VN2000: Bắc Giang (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-00 EPSG:9214',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-00',
  },
  {
    id: 75,
    name: 'VN2000: Bắc Kạn (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-30 EPSG:9213',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-30',
  },
  {
    id: 76,
    name: 'VN2000: Bạc Liêu (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 77,
    name: 'VN2000: Bắc Ninh (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 78,
    name: 'VN2000: Bến Tre (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 79,
    name: 'VN2000: Bình Định (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-15 EPSG:9217',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-15',
  },
  {
    id: 80,
    name: 'VN2000: Bình Dương (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 81,
    name: 'VN2000: Bình Phước (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-15 EPSG:9212',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-15',
  },
  {
    id: 82,
    name: 'VN2000: Bình Thuận (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 83,
    name: 'VN2000: Cà Mau (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-30 EPSG:9207',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-30',
  },
  {
    id: 84,
    name: 'VN2000: Cần Thơ (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 85,
    name: 'VN2000: Cao Bằng (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 86,
    name: 'VN2000: Đà Nẵng (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 87,
    name: 'VN2000: Đắc Lắc (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 88,
    name: 'VN2000: Đồng Nai (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 89,
    name: 'VN2000: Đồng Tháp (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 90,
    name: 'VN2000: Điện Biên (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 103-00 EPSG:9205',
    proj: '+proj=tmerc +lat_0=0 +lon_0=103 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_103-00',
  },
  {
    id: 91,
    name: 'VN2000: Gia Lai (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 92,
    name: 'VN2000: Hà Giang (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 93,
    name: 'VN2000: Hà Nam (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 94,
    name: 'VN2000: Hà Nội (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 95,
    name: 'VN2000: Hà Tây (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 96,
    name: 'VN2000: Hà Tĩnh (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 97,
    name: 'VN2000: Hải Dương (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 98,
    name: 'VN2000: Hải Phòng (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 99,
    name: 'VN2000: Hoà Bình (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-00 EPSG:9211',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-00',
  },
  {
    id: 100,
    name: 'VN2000: Hưng Yên (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 101,
    name: 'VN2000: Khánh Hoà (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-15 EPSG:9217',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-15',
  },
  {
    id: 102,
    name: 'VN2000: Kiên Giang (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-30 EPSG:9207',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-30',
  },
  {
    id: 103,
    name: 'VN2000: Kon Tum (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-30 EPSG:9216',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-30',
  },
  {
    id: 104,
    name: 'VN2000: Lai Châu (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 103-00 EPSG:9205',
    proj: '+proj=tmerc +lat_0=0 +lon_0=103 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_103-00',
  },
  {
    id: 105,
    name: 'VN2000: Lâm Đồng (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 106,
    name: 'VN2000: Lạng Sơn (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-15 EPSG:9215',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-15',
  },
  {
    id: 107,
    name: 'VN2000: Lào Cai (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 108,
    name: 'VN2000: Long An (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 109,
    name: 'VN2000: Nam Định (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 110,
    name: 'VN2000: Nghệ An (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 111,
    name: 'VN2000: Ninh Bình (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 112,
    name: 'VN2000: Long An (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 113,
    name: 'VN2000: Nam Định (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 114,
    name: 'VN2000: Nghệ An (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 115,
    name: 'VN2000: Ninh Bình (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 116,
    name: 'VN2000: Ninh Thuận (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-15 EPSG:9217',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-15',
  },
  {
    id: 117,
    name: 'VN2000: Phú Thọ (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 118,
    name: 'VN2000: Phú Yên (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 119,
    name: 'VN2000: Quảng Bình (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-00 EPSG:9211',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-00',
  },
  {
    id: 120,
    name: 'VN2000: Quảng Nam (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 121,
    name: 'VN2000: Quảng Ngãi (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-00',
  },
  {
    id: 122,
    name: 'VN2000: Quảng Ninh (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 123,
    name: 'VN2000: Quảng Trị (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-15 EPSG:9212',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-15',
  },
  {
    id: 124,
    name: 'VN2000: Sóc Trăng (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 125,
    name: 'VN2000: Sơn La (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-00 EPSG:9206',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-00',
  },
  {
    id: 126,
    name: 'VN2000: Tây Ninh (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 127,
    name: 'VN2000: Thái Bình (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 128,
    name: 'VN2000: Thái Nguyên (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-30 EPSG:9213',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-30',
  },
  {
    id: 129,
    name: 'VN2000: Thanh Hoá (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 130,
    name: 'VN2000: Tiền Giang (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 131,
    name: 'VN2000: Hồ Chí Minh (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 132,
    name: 'VN2000: Trà Vinh (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 133,
    name: 'VN2000: Thừa Thiên-Huế (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-00 EPSG:9214',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-00',
  },
  {
    id: 134,
    name: 'VN2000: Tuyên Quang (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-00 EPSG:9211',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-00',
  },
  {
    id: 135,
    name: 'VN2000: Vĩnh Long (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 136,
    name: 'VN2000: Vĩnh Phúc (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 137,
    name: 'VN2000: Yên Bái (Lệch 200 mét)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 138,
    name: 'VN2000: An Giang (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 139,
    name: 'VN2000: Bắc Ninh (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-00 EPSG:9214',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-00',
  },
  {
    id: 140,
    name: 'VN2000: Cà Mau (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-30 EPSG:9207',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-30',
  },
  {
    id: 141,
    name: 'VN2000: Cao Bằng (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 142,
    name: 'VN2000: Đắk Lắk (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-30 EPSG:9218',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-30',
  },
  {
    id: 143,
    name: 'VN2000: Điện Biên (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 103-00 EPSG:9205',
    proj: '+proj=tmerc +lat_0=0 +lon_0=103 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_103-00',
  },
  {
    id: 144,
    name: 'VN2000: Đồng Nai (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 145,
    name: 'VN2000: Đồng Tháp (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 146,
    name: 'VN2000: Gia Lai (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-15 EPSG:9217',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-15',
  },
  {
    id: 147,
    name: 'VN2000: Hà Tĩnh (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 148,
    name: 'VN2000: Hưng Yên (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 149,
    name: 'VN2000: Khánh Hòa (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-15 EPSG:9217',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-15',
  },
  {
    id: 150,
    name: 'VN2000: Lai Châu (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 151,
    name: 'VN2000: Lạng Sơn (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-15 EPSG:9215',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-15',
  },
  {
    id: 152,
    name: 'VN2000: Lào Cai (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 153,
    name: 'VN2000: Lâm Đồng (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 154,
    name: 'VN2000: Nghệ An (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 155,
    name: 'VN2000: Ninh Bình (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 156,
    name: 'VN2000: Phú Thọ (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-45 EPSG:9208',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-45',
  },
  {
    id: 157,
    name: 'VN2000: Quảng Ngãi (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 108-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=108 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_108-00',
  },
  {
    id: 158,
    name: 'VN2000: Quảng Ninh (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 159,
    name: 'VN2000: Quảng Trị (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-00 EPSG:9211',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-00',
  },
  {
    id: 160,
    name: 'VN2000: Sơn La (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 104-00 EPSG:9206',
    proj: '+proj=tmerc +lat_0=0 +lon_0=104 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_104-00',
  },
  {
    id: 161,
    name: 'VN2000: Tây Ninh (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 162,
    name: 'VN2000: Thái Nguyên (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-30 EPSG:9213',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-30',
  },
  {
    id: 163,
    name: 'VN2000: Thanh Hóa (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 164,
    name: 'VN2000: Thành phố Cần Thơ (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 165,
    name: 'VN2000: Thành phố Đà Nẵng (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-45 EPSG:5899',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-45',
  },
  {
    id: 166,
    name: 'VN2000: Thành phố Hà Nội (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-00',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-00',
  },
  {
    id: 167,
    name: 'VN2000: Thành phố Hải Phòng (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 168,
    name: 'VN2000: Thành phố Hồ Chí Minh (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-45 EPSG:9210',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-45',
  },
  {
    id: 169,
    name: 'VN2000: Thừa Thiên-Huế (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 107-00 EPSG:9214',
    proj: '+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_107-00',
  },
  {
    id: 170,
    name: 'VN2000: Tuyên Quang (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 106-00 EPSG:9211',
    proj: '+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_106-00',
  },
  {
    id: 171,
    name: 'VN2000: Vĩnh Long (Sau sáp nhập)',
    description_en: 'Vietnam integration 3° local',
    description_vi: 'VN-2000 / TM-3 105-30 EPSG:9209',
    proj: '+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs',
    srs_code: 'VN-2000_TM-3_105-30',
  },
  {
    id: 172,
    name: 'VN-2000 / UTM zone 48N',
    description_en: 'VN-2000 / UTM zone 48N',
    description_vi: 'Hệ VN-2000 múi chiếu 48 độ Bắc EPSG:3405',
    proj: '+proj=utm +zone=48 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,-0.00928836,0.01975479,-0.00427372,0.252906278 +units=m +no_defs +type=crs',
    srs_code: 'EPSG:3405',
  },
  {
    id: 173,
    name: 'VN-2000 / UTM zone 49N',
    description_en: 'VN-2000 / UTM zone 49N',
    description_vi: 'Hệ VN-2000 múi chiếu 49 độ Bắc EPSG:3406',
    proj: '+proj=utm +zone=49 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,-0.00928836,0.01975479,-0.00427372,0.252906278 +units=m +no_defs +type=crs',
    srs_code: 'EPSG:3406',
  },
];
